import { gql } from '@apollo/client';

export const ADMIN_VENUES_QUERY = gql`
  query AdminVenues(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
    $search: String
  ) {
    adminVenues(
      after: $after
      first: $first
      orderBy: $orderBy
      order: $order
      search: $search
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        email
        timezone
        marketplaceRank
        subscription {
          planName
          cardApplicationFeeRate
          achApplicationFeeRate
          monthlyRate
          billingInterval
          tier
          stripeSubscriptionId
        }
        featureScope {
          basicFeaturesEnabled
          proFeaturesEnabled
          premiumFeaturesEnabled
          enterpriseFeaturesEnabled
        }
        customerStartedAt
        achEnabled
        spacesCount
        eventsCount
        createdAt
        stripeAccount {
          id
        }
        squareAccount {
          id
        }
        websiteUrl
        organization {
          id
          name
        }
        users(limit: 1) {
          id
          magicLoginLink
        }
        address {
          id
          formattedAddress
        }
      }
    }
  }
`;
